module.exports = __webpack_public_path__ + "static/media/XEM.5ddbc861.svg";